/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxSpecialDto } from '../../models/backend-tax-special-dto';
import { BackendTaxSpecialRequestDto } from '../../models/backend-tax-special-request-dto';

export interface ProjectTaxesTaxSpecialUpdate$Params {
  id: number;
  body: BackendTaxSpecialRequestDto;
}

export function projectTaxesTaxSpecialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxSpecialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxSpecialUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxSpecialDto>;
    }),
  );
}

projectTaxesTaxSpecialUpdate.PATH = '/api/project_taxes/tax_special/{id}/';
